import React from 'react';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

// import pages
import Home from './Home';
import Vendor from './Vendor';

function App() {
  return (
    <Router>
      <Switch>
        <Route exact path="/" component={Vendor} />
      </Switch>
    </Router>
  );
}

export default App;
